import PropTypes from "prop-types";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // Correct import
import { useState, useEffect, useCallback  } from "react";
import logoData from './logo.json';
import { getProductos, createNMIncidenteProducto, getIncidentesActivos, getEmpleadoById} from "../api";

const FilterTableValeNuevo = (usuario) => {
  const URL = process.env.REACT_APP_URL;
  const [Producto, setProducto] = useState([]);
  const [filteredProducto, setFilteredProducto] = useState([]);
  const [formData, setFormData] = useState({ id: 0, id_incidente: "", selectedProductos: [], nota: "", tipoIncidente: "" });
  const [error, setError] = useState("");
  const [selectedProductos, setSelectedProductos] = useState([]);
  const [receiptData, setReceiptData] = useState({});
  const [showReceiptIcon, setShowReceiptIcon] = useState([]);
  const [incidentes, setIncidentes] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [open, setOpen] = useState(false);
  const [usuario_detalles, setUsuarioDetalles] = useState("");
  const fechaNow = new Date().toLocaleString(); // Fetch current datetime

  // ✅ fetchUsuarioDetalles con dependencia 'usuario'
  const fetchUsuarioDetalles = useCallback(async () => {
    try {
      if (usuario.length > 0 && usuario[0].creado_por) {
        const detalles = await getEmpleadoById(usuario[0].creado_por);
        setUsuarioDetalles(detalles);
      }
    } catch (error) {
      console.error("Error fetching usuario_detalles:", error);
    }
  }, [usuario]);

  // ✅ Wrapping en useCallback
  const fetchDropdownData = useCallback(async () => {
    try {
      const incidenteResponse = await getIncidentesActivos();
      setIncidentes(incidenteResponse.data.incidentes);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  }, []);

  // ✅ Wrapping en useCallback
  const fetchProducto = useCallback(async () => {
    try {
      const response = await getProductos();
      setProducto(response.data);
      setFilteredProducto(response.data);
    } catch (error) {
      console.error("Error fetching producto:", error);
      setError("Error loading data");
    }
  }, []);

  // ✅ useEffect sin warnings
  useEffect(() => {
    fetchProducto();
    fetchDropdownData();
  }, [fetchProducto, fetchDropdownData]);

  useEffect(() => {
    fetchUsuarioDetalles();
  }, [fetchUsuarioDetalles]);

  useEffect(() => {
    if (filterText) {
      const filtered = Producto.filter((Producto) =>
        Producto.id?.toString().includes(filterText.toLowerCase()) ||
        Producto.descripcion?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.color?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.marca?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.familia?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.estado?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.familia_tipo?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.codigo?.toLowerCase().includes(filterText.toLowerCase()) ||
        (Producto.creado_por || "").toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredProducto(filtered);
    } else {
      setFilteredProducto(Producto);
    }
  }, [filterText, Producto]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Get nombres from selected incidente
      const selectedIncidente = incidentes.find(
        (i) => String(i.id) === String(formData.id_incidente)
      );
      const nombres = selectedIncidente ? selectedIncidente.empleado : "";
      const tipo_incidente = selectedIncidente ? selectedIncidente.tipo_incidente : "";
  
      const formDataToSend = new FormData();
      formDataToSend.append("id_incidente", formData.id_incidente);
      formDataToSend.append("nota", formData.nota);
      formDataToSend.append("selectedProductos", JSON.stringify(selectedProductos));
  
      let response;
        response = await createNMIncidenteProducto(formDataToSend);
        alert("Incidente registrado con éxito.");
        fetchProducto();
  
      if (response.status === 200) {
        setShowReceiptIcon(true);

        setReceiptData({
          id_incidente: formData.id_incidente,
          nota: formData.nota,
          tipo_incidente: tipo_incidente,
          nombres: nombres,
          productos: selectedProductos,
          incidente: selectedIncidente
        });
      }
  
      setFormData({
        id: 0,
        id_incidente: "",
        tipo_incidente: "",
        nota: "",
        selectedProductos: []
      });
  
      fetchProducto();
    } catch (error) {
      console.error("Error procesando el incidente:", error);
    }
  };
  
  const handleVale = (producto) => {
    setSelectedProductos((prevProductos) => {
      if (prevProductos.length >= 12) {
        alert("Máximo 12 productos por vale.");
        return prevProductos;
      }
  
      const alreadyAdded = prevProductos.some(p => p.id === producto.id);
      if (alreadyAdded) {
        alert("Este producto ya fue agregado.");
        return prevProductos;
      }
  
      return [...prevProductos, producto];
    });
  };
  

  const handleRemoveProducto = (id) => {
    setSelectedProductos((prevProductos) =>
      prevProductos.filter((producto) => producto.id !== id)
    );
  };

  const handleClearFilters = () => {
    setFormData({ id: 0, id_incidente: "", selectedProductos: [], nota: "", tipo_incidente: "" });
    setSelectedProductos([]); // <-- ¡Esto borra los productos agregados!
  };

  const handleView = async (producto) => {
    setImageUrl(`${URL}${producto}?${Date.now()}`);
    setOpen(true);
  };

  // Handle closing the modal
  const handleCloseModal = () => {
    setOpen(false);
  };

  const generatePDF = () => {
    if (!receiptData) return;
  
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
  
  
    // 👉 TÍTULO CENTRADO
    doc.setFontSize(9);
    doc.setTextColor(170, 170, 170);
    doc.rect(15, 5, 90, 13);
    doc.text("Firma Entregado Almacen", 16, 12);
    doc.rect(105, 5, 90, 13);
    doc.text("Firma Entregado Personal", 106, 12);
    doc.rect(15, 18, 90, 13);
    doc.text("Firma Recibido Almacen", 16, 25);
    doc.rect(105, 18, 90, 13);
    doc.text("Firma Recibido Personal", 106, 25);
    // 👉 Línea divisoria
    doc.setLineWidth(0.5);
    doc.line(10, 31, pageWidth - 10, 31);
    doc.setTextColor(0,0,0);

    // 👉 Detalles del incidente
    doc.text(`ID Incidente: ${receiptData.id_incidente}`, 10, 35);
    doc.text(`ID Vale: ${receiptData.id_incidente}`, 35, 35);
    doc.text(`Responsable: ${receiptData.nombres}`, 60, 35);
    doc.text(`Fecha: ${fechaNow}`, 140, 35);
    doc.text(`Nota: ${receiptData.nota}`, 10, 40);
    doc.text(`Descripcion: ${receiptData.incidente.nota}`, 10, 45);
    
    let y = 48;
    let z = 183;
  
    const productosArray = Array.isArray(receiptData.productos)
      ? receiptData.productos
      : JSON.parse(receiptData.productos);
  
    const tableColumn = [
      "#",
      "IDdb",
      "Código",
      "Descripción",
      "Tipo",
      "Cantidad",
      "Precio Bruto",
      "Recibido Sello y Firma",
    ];
  
    const tableRows = productosArray.map((prod, index) => [
      index + 1,
      prod.id,  // 👈 Añadimos esta nueva columna
      prod.codigo,
      prod.descripcion,
      prod.familia_tipo,  // 👈 Añadimos esta nueva columna
      prod.cantidad,
      prod.precio_bruto,
      "",
    ]);
  
    // 👉 Tabla - ORIGINAL
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: y,
      theme: "grid",
      styles: { fontSize: 8 },
      headStyles: { fillColor: [12, 64, 104] },
    });
  
  // 👉 Línea divisoria
  doc.setLineWidth(0.5);
  doc.setLineDashPattern([1, 1], 0); // [dash length, gap length]
  doc.line(10, 140, pageWidth - 10, 140);
  doc.setLineDashPattern([], 0); // Reset to solid lines if needed afterward

    // 👉 COPIA
    doc.setFontSize(9);
    doc.setTextColor(170, 170, 170);
    doc.rect(15, 141, 90, 13);
    doc.text("Firma Entregado Almacen", 16, 148);
    doc.rect(105, 141, 90, 13);
    doc.text("Firma Entregado Personal", 106, 148);
    doc.rect(15, 154, 90, 13);
    doc.text("Firma Recibido Almacen", 16, 161);
    doc.rect(105, 154, 90, 13);
    doc.text("Firma Recibido Personal", 106, 161);
    // 👉 Línea divisoria
    doc.setLineWidth(0.5);
    doc.line(10, 167, pageWidth - 10, 167);
    doc.setTextColor(0,0,0);
  
    doc.text(`ID Incidente: ${receiptData.id_incidente}`, 10, 170);
    doc.text(`ID Vale: ${receiptData.id_incidente}`, 35, 170);
    doc.text(`Responsable: ${receiptData.nombres}`, 60, 170);
    doc.text(`Fecha: ${fechaNow}`, 140, 170);
    doc.text(`Nota: ${receiptData.nota}`, 10, 175);
    doc.text(`Descripcion: ${receiptData.incidente.nota}`, 10, 180);
      
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: z,
      theme: "grid",
      styles: { fontSize: 8 },
      headStyles: { fillColor: [12, 64, 104] },
    });
  
    doc.save("recibo_incidente.pdf");
  };


  return (
    <div>
      <form onSubmit={handleSubmit}>
        <center>
          <h2> Agregar Vale</h2>
        </center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input"
            hidden
          />
        </div>
        <div className="input-group">
          <label className="label3">Incidente</label>
          <select
            name="id_incidente"
            value={formData.id_incidente}
            onChange={handleChange}
            className="input-form-2"
          >
            {incidentes.map((incidente) => (
              <option key={incidente.id} value={incidente.id}>
                {incidente.empleado} - {incidente.nota} - {incidente.estado} - {incidente.tipo_incidente}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group">
        <label className="label2">Nota</label>
        <textarea
          name="nota"
          value={formData.nota}
          onChange={handleChange}
          className="input-form-2"
          rows="2" // Adjust the number of rows for better visibility
          cols="60" // Optional: Adjust width if needed
        />
      </div>
      {showReceiptIcon && (
        <button onClick={generatePDF} className="button-form-blue">
          🖨️ Descargar Recibo
        </button>
      )}
        <center>
          <button type="submit" className="button-form-blue">
            "Registrar"
          </button>
          <button type="reset" className="button-form-gray" onClick={handleClearFilters}>
            Limpiar/Reiniciar
          </button>
        </center>
      <hr />
      {/* Selected Products Table */}
      {selectedProductos.length > 0 && (
        <>
          <h3>Nuevo Vale</h3>
          <table className="table">
            <thead>
              <tr>
                <th>Acción</th>
                <th>ID</th>
                <th>Código</th>
                <th>Cantidad</th>
                <th>Descripción</th>
                <th>Familia</th>
                <th>Tipo</th>
                <th>Marca</th>
                <th>Ubicación</th>
                <th>Color</th>
                <th>Nota</th>
                <th>Proveedor-Factura</th>
              </tr>
            </thead>
            <tbody>
              {selectedProductos.map((producto) => (
                <tr key={producto.id}>
                  <td>
                    <button onClick={() => handleRemoveProducto(producto.id)} className="button-table-red">
                      Eliminar
                    </button>
                  </td>
                  <td>{producto.id}</td>
                  <td>{producto.codigo}</td>
                  <td>
                    {producto.familia_tipo === "Consumible" ? (
                      <input
                        type="number"
                        min="1"
                        max={producto.cantidad}
                        value={producto.cantidad}
                        onChange={(e) => {
                          const newCantidad = parseInt(e.target.value);
                          if (!isNaN(newCantidad) && newCantidad <= producto.cantidad && newCantidad >= 1) {
                            setSelectedProductos((prev) =>
                              prev.map((p) =>
                                p.id === producto.id ? { ...p, cantidad: newCantidad } : p
                              )
                            );
                          }
                        }}
                        className="input-small"
                      />
                    ) : (
                      producto.cantidad
                    )}
                  </td>

                  <td>{producto.descripcion}</td>
                  <td>{producto.familia}</td>
                  <td>{producto.familia_tipo}</td>
                  <td>{producto.marca}</td>
                  <td>{producto.ubicacion}</td>
                  <td>{producto.color}</td>
                  <td>{producto.nota}</td>
                  <td>{producto.rfc_cliente_proveedor}-{producto.folio_fiscal}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      </form>
      <hr />
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por id, descripción, materia o familia..."
          className="input3"
        />
      </div>
        <div style={{ marginBottom: "10px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <div style={{ width: "20px", height: "20px", backgroundColor: "#cffbd1", border: "1px solid #aaa" }}></div>
            <span>ENTRADA</span>
          </div>
        </div>

      {filteredProducto.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <div className="product-grid">
        {filteredProducto.slice(0, 18).map((producto) => {
          const cardStyle = {
            backgroundColor: 
              producto.estado === "ENTRADA" ? "#cffbd1" :
              producto.estado === "SALIDA" ? "#93c1ff" :
              producto.estado === "EQ. DAÑADOS" ? "#ffb4b4" :
              producto.estado === "DESTRUCCION" ? "#a67eff" :
              producto.estado === "RENTA" ? "#ffc17e" :
              producto.estado === "EXTRAVIADO" ? "#c93328" :
              "#dcdcdc", // Default color
            Size: "15px",
            display: 
              producto.estado === "ENTRADA" ? "block":
              producto.estado === "SALIDA" ? "none":
              producto.estado === "EQ. DAÑADOS" ? "none" :
              producto.estado === "DESTRUCCION" ? "none":
              producto.estado === "RENTA" ? "none":
              producto.estado === "EXTRAVIADO" ? "none":
              "none", // Default color
          };

          return (
            <div key={producto.id} className="product-card" style={cardStyle}>
              <div className="card-header">
                <button onClick={() => handleVale(producto)} className="button-blue">Agregar</button>
              </div>
              <h2>{producto.descripcion} ({producto.estado})</h2>
              <p><strong>ID:</strong> {producto.id}   <strong>Familia:</strong> {producto.familia}<br></br>
              <strong>Código:</strong> {producto.codigo} <strong>Color:</strong> {producto.color}<br></br>
              <strong>Tipo:</strong> {producto.familia_tipo}<br></br>
              <strong>Marca:</strong> {producto.marca}<br></br>
              <strong>Ubicación:</strong> {producto.ubicacion}<br></br>
              <strong>Nota:</strong> {producto.nota}<br></br>
              <strong>Cantidad:</strong> {producto.cantidad}<br></br>
              <strong>Proveedor-Factura:</strong> {producto.rfc_cliente_proveedor}-{producto.folio_fiscal}<br></br>
              <strong>Creacion:</strong> {producto.fecha_creacion}<br></br>
              <hr></hr><strong>Responsable:</strong> {producto.creado_por}<br></br>
              <strong>Ultima Actualizacion:</strong> {producto.fecha_ultima_actualizacion}</p>
              <button onClick={() => handleView(producto.path_imagen)} className="button-gray">
                <img
                  src={`${URL}${producto.path_imagen}?${Date.now()}`}
                  alt="Producto sin imagen"
                  width="250px"
                />
              </button>
            </div>
          );
        })}
      </div>
      )}

      {/* Modal */}
      {open && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={handleCloseModal}>
              ✖
            </button>
            <img src={imageUrl} alt="Product" className="modal-image"/>
          </div>
        </div>
      )}
    </div>
  );
};

FilterTableValeNuevo.propTypes = {
  producto: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    })
  ),
};

export default FilterTableValeNuevo;
